function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnquiry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 382.398,
    style: {
      fill: "#EBEBEB"
    },
    width: 500,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.779,
    y: 398.494,
    style: {
      fill: "#EBEBEB"
    },
    width: 33.122,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.527,
    y: 401.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 8.693,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.586,
    y: 389.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 19.192,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.459,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 43.193,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.556,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 6.333,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.471,
    y: 395.111,
    style: {
      fill: "#EBEBEB"
    },
    width: 93.676,
    height: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M237.014,337.8H43.915c-3.147,0-5.708-2.561-5.708-5.708V60.66c0-3.147,2.561-5.708,5.708-5.708 h193.099c3.146,0,5.707,2.561,5.707,5.708v271.432C242.721,335.239,240.16,337.8,237.014,337.8z M43.915,55.203 c-3.01,0-5.458,2.448-5.458,5.458v271.432c0,3.01,2.448,5.458,5.458,5.458h193.099c3.009,0,5.457-2.448,5.457-5.458V60.66 c0-3.009-2.448-5.458-5.457-5.458H43.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M453.31,337.8H260.212c-3.147,0-5.707-2.561-5.707-5.708V60.66c0-3.147,2.561-5.708,5.707-5.708 H453.31c3.148,0,5.708,2.561,5.708,5.708v271.432C459.019,335.239,456.458,337.8,453.31,337.8z M260.212,55.203 c-3.009,0-5.457,2.448-5.457,5.458v271.432c0,3.01,2.448,5.458,5.457,5.458H453.31c3.01,0,5.458-2.448,5.458-5.458V60.66 c0-3.009-2.448-5.458-5.458-5.458H260.212z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9732 -0.2298 0.2298 0.9732 -15.6299 45.0978)",
    style: {
      fill: "#E0E0E0"
    },
    cx: 185.848,
    cy: 89.668,
    rx: 23.554,
    ry: 23.554
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9871 -0.1602 0.1602 0.9871 -11.9635 30.9274)",
    style: {
      fill: "#F0F0F0"
    },
    cx: 185.848,
    cy: 89.668,
    rx: 20.027,
    ry: 20.027
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#F0F0F0",
      stroke: "#E0E0E0",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 186.792,75.93 186.792,89.93 196.07,84.68  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M73.785,345.28c0.013-0.396,1.344-39.676,7.733-45.889c6.214-6.041,13.347-0.225,13.646,0.025 l0.641-0.768c-0.081-0.068-8.13-6.639-14.984,0.025c-6.676,6.492-7.982,44.94-8.035,46.574L73.785,345.28z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M73.237,352.999c0.046-0.47,4.367-47.156-12.683-66.724l-0.754,0.656 c16.767,19.243,12.487,65.505,12.442,65.97L73.237,352.999z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M73.867,348.061l0.998-0.066c-0.035-0.529-3.337-53.076,9.169-64.579l-0.677-0.736 C70.501,294.505,73.723,345.879,73.867,348.061z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M72.239,348.032l1-0.008c-0.012-1.447-0.413-35.493-10.083-41.035 c-2.15-1.233-4.255-1.439-6.257-0.61c-5.848,2.419-8.746,12.826-8.866,13.268l0.965,0.264 c0.028-0.104,2.89-10.377,8.285-12.608c1.701-0.702,3.509-0.517,5.377,0.554C71.835,313.115,72.236,347.683,72.239,348.032z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M76.005,348.056l0.998-0.057c-0.015-0.268-1.459-26.904,5.729-36.289 c1.742-2.273,3.632-3.357,5.63-3.218c4.71,0.329,8.66,7.222,8.699,7.291l0.871-0.492c-0.171-0.303-4.252-7.429-9.499-7.796 c-2.347-0.167-4.535,1.049-6.495,3.607C74.525,320.782,75.941,346.948,76.005,348.056z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M74.429,351.679c0.196-2.584,4.699-63.402-3.225-74.119l-0.804,0.594 c7.705,10.421,3.079,72.82,3.031,73.449L74.429,351.679z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M54.743,312.542c0,0,4.754,1.752,3.34,5.89c-1.413,4.137-16.445,10.946-16.445,10.946 s-6.295-5.77-0.514-15.154C46.906,304.84,54.615,309.581,54.743,312.542z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M75.408,304.666c0,0-5.062-0.212-5.349,4.151c-0.288,4.363,10.966,16.432,10.966,16.432 s8.031-2.903,6.306-13.79C85.606,300.573,76.666,301.983,75.408,304.666z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M79.694,283.784c0,0-3.375-0.362-3.103-2.418s13.119-7.346,20.699,1.209 c0,0-4.854,8.337-11.87,8.446C78.404,291.13,79.694,283.784,79.694,283.784z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M73.405,278.792c0,0,3.056,1.478,3.912-0.411c0.857-1.888-7.249-13.173-18.206-9.922 c0,0-0.29,9.643,5.606,13.446C70.614,285.709,73.405,278.792,73.405,278.792z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M89.383,310.879c0,0-2.329-1.881,0.184-2.798c2.514-0.918,14.847-0.657,14.976,11.56 c0,0-14.365,2.387-16.143-2.266C86.623,312.72,89.383,310.879,89.383,310.879z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M60.091,283.478c0,0,2.329-1.881-0.184-2.799c-2.514-0.918-14.847-0.657-14.976,11.56 c0,0,14.365,2.387,16.143-2.267C62.852,285.319,60.091,283.478,60.091,283.478z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M67.685,293.319c0,0,0.205-2.286-1.641-1.39c-1.846,0.896-8.275,7.832-1.61,14.415 c0,0,8.972-6.645,7.354-10.105C70.172,292.779,67.685,293.319,67.685,293.319z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M91.466,296.577c0,0-1.392-1.825,0.647-2.051c2.039-0.226,11.177,2.213,9.049,11.336 c0,0-11.133-0.837-11.61-4.626C89.075,297.446,91.466,296.577,91.466,296.577z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "53.855,381.894 92.053,381.894 96.174,340.073 49.734,340.073  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.694,
    y: 335.458,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 145.9073 680.1448)",
    style: {
      fill: "#E6E6E6"
    },
    width: 50.519,
    height: 9.228
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 45.681,
    y: 144.278,
    style: {
      fill: "#E0E0E0"
    },
    width: 90.645,
    height: 4.657
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.854,
    y: 127.11,
    style: {
      fill: "#EBEBEB"
    },
    width: 3.993,
    height: 17.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.163,
    y: 127.11,
    style: {
      fill: "#EBEBEB"
    },
    width: 3.993,
    height: 17.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.571,
    y: 126.896,
    transform: "matrix(0.9855 -0.1698 0.1698 0.9855 -21.6347 18.0285)",
    style: {
      fill: "#EBEBEB"
    },
    width: 3.993,
    height: 17.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.802,
    y: 129.373,
    style: {
      fill: "#EBEBEB"
    },
    width: 3.993,
    height: 14.905
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.981,
    y: 129.373,
    style: {
      fill: "#EBEBEB"
    },
    width: 3.993,
    height: 14.905
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.149,
    y: 129.373,
    style: {
      fill: "#EBEBEB"
    },
    width: 3.993,
    height: 14.905
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.072,
    y: 129.117,
    transform: "matrix(0.9762 -0.2169 0.2169 0.9762 -27.7639 20.1848)",
    style: {
      fill: "#EBEBEB"
    },
    width: 3.993,
    height: 14.905
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.251,
    y: 126.258,
    style: {
      fill: "#EBEBEB"
    },
    width: 1.997,
    height: 18.02
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.004,
    y: 126.258,
    style: {
      fill: "#EBEBEB"
    },
    width: 1.997,
    height: 18.02
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.171,
    y: 130.69,
    style: {
      fill: "#EBEBEB"
    },
    width: 19.458,
    height: 13.434
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 45.681,
    y: 179.046,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 182.0077 362.7493)",
    style: {
      fill: "#E0E0E0"
    },
    width: 90.645,
    height: 4.657
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.161,
    y: 161.879,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 260.3151 340.9246)",
    style: {
      fill: "#EBEBEB"
    },
    width: 3.993,
    height: 17.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.851,
    y: 161.879,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 221.6956 340.9246)",
    style: {
      fill: "#EBEBEB"
    },
    width: 3.993,
    height: 17.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.443,
    y: 161.664,
    transform: "matrix(-0.9855 -0.1698 0.1698 -0.9855 144.6961 352.8726)",
    style: {
      fill: "#EBEBEB"
    },
    width: 3.993,
    height: 17.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.213,
    y: 164.141,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 250.4186 343.187)",
    style: {
      fill: "#EBEBEB"
    },
    width: 3.993,
    height: 14.905
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.034,
    y: 164.141,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 232.061 343.187)",
    style: {
      fill: "#EBEBEB"
    },
    width: 3.993,
    height: 14.905
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.865,
    y: 164.141,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 185.724 343.187)",
    style: {
      fill: "#EBEBEB"
    },
    width: 3.993,
    height: 14.905
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.942,
    y: 163.885,
    transform: "matrix(-0.9762 -0.2169 0.2169 -0.9762 168.2433 361.1396)",
    style: {
      fill: "#EBEBEB"
    },
    width: 3.993,
    height: 14.905
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.759,
    y: 161.026,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 241.5156 340.0723)",
    style: {
      fill: "#EBEBEB"
    },
    width: 1.997,
    height: 18.02
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.007,
    y: 161.026,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 194.0098 340.0723)",
    style: {
      fill: "#EBEBEB"
    },
    width: 1.997,
    height: 18.02
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.379,
    y: 165.458,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 128.2161 344.3505)",
    style: {
      fill: "#EBEBEB"
    },
    width: 19.458,
    height: 13.434
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 264.975,
    y: 111.732,
    style: {
      fill: "#E6E6E6"
    },
    width: 164.446,
    height: 145.921
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.093,
    y: 115.732,
    style: {
      fill: "#F0F0F0"
    },
    width: 156,
    height: 138
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "305.704,115.732 269.093,253.432 269.093,188.727 288.423,115.732  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "318.671,115.732 281.738,253.732 275.844,253.732 312.776,115.732  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "425.093,202.811 425.093,224.862 417.62,253.732 411.725,253.732  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.875,
    y: 113.251,
    style: {
      fill: "#E6E6E6"
    },
    width: 2.628,
    height: 143.563
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.802,
    y: 113.251,
    style: {
      fill: "#E6E6E6"
    },
    width: 2.628,
    height: 143.563
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M442.763,357.103c1.01-1.694-0.414-4.244-2.386-4.273c0.864-2.431,0.012-5.37-2.02-6.961 c-0.256-0.201-0.551-0.389-0.876-0.389c-0.349-0.001-0.658,0.211-0.942,0.415c-1.858,1.335-3.717,2.67-5.575,4.005 c-0.425,0.306-0.866,0.629-1.106,1.094c-1.139,2.208,2.968,5.037,1.279,6.858c-0.485,0.523-1.266,0.631-1.871,1.009 c-1.327,0.829-1.487,2.651-2.105,4.088c-0.618,1.437-2.774,2.553-3.599,1.223c0.609-1.379-1.234-2.567-2.731-2.742 c-1.477-0.173-3.06-0.257-3.887-1.661c-2.124,1.856-6.879-3.323-6.77-5.411c-1.746,0.133-2.935,1.768-3.317,3.403 c-0.396,1.697-0.151,3.465-0.179,5.204c-0.053,3.381-1.145,6.693-1.085,10.074c0.046,2.631,1.063,5.552,3.472,6.611 c1.16,0.51,2.47,0.51,3.736,0.502c9.143-0.059,18.286-0.117,27.429-0.176c0.658-0.004,1.345-0.015,1.929-0.32 c1.238-0.646,1.499-2.272,1.614-3.663c0.491-5.959,0.982-11.918,1.473-17.877C444.418,357.778,443.591,357.441,442.763,357.103z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M444.364,328.11h-3.08h-8.48h-3.09h-8.47h-3.09h-8.47h-3.09h-4.79l0.35,4.3l0.25,3.07l0.65,7.99 l0.37,4.59l0.49,6.11l0.21,2.62l0.07,0.78l0.25,3.08l0.34,4.22l0.21,2.62l0.22,2.66l0.25,3.08l0.19,2.33l0.21,2.62l0.09,1.14 h5.6h4.73h6.83h4.73h6.83h4.73h5.61l0.09-1.14l0.21-2.61l0.19-2.35l0.25-3.08l0.22-2.65l0.21-2.62l0.34-4.23l0.25-3.07 l0.06-0.78l0.21-2.62l0.5-6.11l0.37-4.58l0.64-8l0.25-3.07l0.35-4.3H444.364z M446.924,330.93L446.924,330.93l-0.82-0.82h0.89 L446.924,330.93z M446.714,333.54l-0.08,1.04l-3.81,3.81l-4.37-4.37l3.91-3.91h0.92L446.714,333.54z M445.614,347.16 l-2.79,2.79l-4.37-4.37l4.37-4.36l3.02,3.02L445.614,347.16z M405.114,344.24L405.114,344.24l3.02-3.02l4.37,4.36l-4.37,4.37 l-2.78-2.79L405.114,344.24z M441.414,339.8l-4.37,4.37l-4.37-4.37l4.37-4.37L441.414,339.8z M434.544,330.11h5l-2.5,2.5 L434.544,330.11z M435.624,345.581l-4.36,4.37l-4.37-4.37l4.37-4.36L435.624,345.581z M421.114,351.36l4.37-4.36l4.36,4.36 l-4.36,4.37L421.114,351.36z M424.064,357.141l-4.37,4.37l-4.36-4.36l4.37-4.37L424.064,357.141z M431.264,352.78l4.36,4.37 l-4.36,4.36l-4.37-4.37L431.264,352.78z M425.484,344.17l-4.37-4.37l4.37-4.37l4.36,4.37L425.484,344.17z M424.064,345.581 l-4.36,4.37l-4.37-4.37l4.37-4.36L424.064,345.581z M413.914,344.17l-4.36-4.37l4.36-4.37l4.37,4.37L413.914,344.17z  M413.914,347l4.37,4.36l-4.37,4.37l-4.36-4.37L413.914,347z M418.284,362.93l-4.37,4.36l-4.36-4.36l4.36-4.37L418.284,362.93z  M419.694,364.341l4.37,4.37l-4.36,4.37l-4.37-4.37L419.694,364.341z M421.114,362.93l4.37-4.37l4.36,4.37l-4.36,4.36 L421.114,362.93z M431.264,364.341l4.36,4.37l-4.36,4.37l-4.37-4.37L431.264,364.341z M437.044,370.12l4.37,4.37l-2.83,2.83 h-3.08l-2.83-2.83L437.044,370.12z M432.674,362.93l4.37-4.37l4.37,4.37l-4.37,4.36L432.674,362.93z M432.674,351.36l4.37-4.36 l4.37,4.36l-4.37,4.37L432.674,351.36z M435.624,334.021l-4.36,4.37l-4.37-4.37l3.91-3.91h0.92L435.624,334.021z  M425.484,332.61l-2.5-2.5h4.99L425.484,332.61z M424.064,334.021l-4.36,4.37l-4.37-4.37l3.91-3.91h0.92L424.064,334.021z  M416.414,330.11l-2.5,2.5l-2.49-2.5H416.414z M408.594,330.11l3.91,3.91l-4.37,4.37l-3.8-3.81l-0.08-1.04l3.42-3.43H408.594z  M404.854,330.11l-0.81,0.81v0l-0.07-0.81H404.854z M404.584,337.66l2.14,2.14l-1.82,1.82L404.584,337.66z M405.774,352.31 l-0.17-2.07v0l1.12,1.12L405.774,352.31L405.774,352.31z M405.984,354.94l2.15-2.16l4.37,4.37l-4.37,4.36l-1.76-1.76 L405.984,354.94z M406.634,363.021l-0.01-0.19l0.1,0.1L406.634,363.021L406.634,363.021z M407.394,372.331l-0.55-6.7l1.29-1.29 l4.37,4.37l-4.37,4.36L407.394,372.331L407.394,372.331z M407.794,377.32l-0.08-1l0.42-0.42l1.42,1.42H407.794z  M409.554,374.49l4.36-4.37l4.37,4.37l-2.83,2.83h-3.08L409.554,374.49z M418.284,377.32l1.42-1.42l1.42,1.42H418.284z  M423.944,377.32l-2.83-2.83l4.37-4.37l4.36,4.37l-2.82,2.83H423.944z M429.844,377.32l1.42-1.42l1.42,1.42H429.844z  M443.164,377.32h-1.76l1.42-1.42l0.42,0.42L443.164,377.32z M443.574,372.331l-0.75,0.74l-4.37-4.36l4.37-4.37l1.29,1.29 L443.574,372.331z M444.344,362.82l-0.02,0.2l-0.09-0.09L444.344,362.82L444.344,362.82z M444.594,359.75l-1.77,1.76 l-4.37-4.36l4.37-4.37l2.16,2.16L444.594,359.75z M445.194,352.32l-0.96-0.96l1.13-1.12L445.194,352.32z M446.384,337.651 l-0.32,3.98l-1.83-1.83L446.384,337.651L446.384,337.651z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M400.723,331.894h49.516c0.908,0,1.643-0.736,1.643-1.643v-2.281c0-0.908-0.736-1.643-1.643-1.643 h-49.516c-0.908,0-1.643,0.736-1.643,1.643v2.281C399.079,331.158,399.815,331.894,400.723,331.894z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M446.431,381.894H404.53c-0.908,0-1.643-0.736-1.643-1.643v-2.281 c0-0.908,0.736-1.643,1.643-1.643h41.901c0.908,0,1.643,0.736,1.643,1.643v2.281 C448.074,381.158,447.339,381.894,446.431,381.894z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M117.895,111.888c1.565-2.364,3.301-4.618,5.206-6.736c18.024-20.041,49.677-26.298,73.97-14.62 c25.615,12.312,40.618,40.624,66.152,53.103c23.119,11.298,50.365,7.621,75.922,4.63s53.577-4.455,74.771,10.137 c34.905,24.031,29.542,75.714,4.135,104.558c-15.237,17.299-37.4,28.013-60.321,30.481c-16.653,1.793-36.008,0.435-47.201,12.895 c-5.311,5.912-7.563,13.863-10.152,21.377c-9.2,26.704-25.875,52.376-51.339,64.597c-25.464,12.22-60.452,6.754-75.491-17.154 c-12.239-19.456-8.853-44.551-4.265-67.074c4.588-22.523,9.785-46.799,0.327-67.748c-11.079-24.539-39.066-37.182-53.23-60.08 C103.7,159.753,104.659,131.885,117.895,111.888z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M117.895,111.888c1.565-2.364,3.301-4.618,5.206-6.736 c18.024-20.041,49.677-26.298,73.97-14.62c25.615,12.312,40.618,40.624,66.152,53.103c23.119,11.298,50.365,7.621,75.922,4.63 s53.577-4.455,74.771,10.137c34.905,24.031,29.542,75.714,4.135,104.558c-15.237,17.299-37.4,28.013-60.321,30.481 c-16.653,1.793-36.008,0.435-47.201,12.895c-5.311,5.912-7.563,13.863-10.152,21.377c-9.2,26.704-25.875,52.376-51.339,64.597 c-25.464,12.22-60.452,6.754-75.491-17.154c-12.239-19.456-8.853-44.551-4.265-67.074c4.588-22.523,9.785-46.799,0.327-67.748 c-11.079-24.539-39.066-37.182-53.23-60.08C103.7,159.753,104.659,131.885,117.895,111.888z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shadow_1_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_x3C_Path_x3E__359_",
    style: {
      fill: "#F5F5F5"
    },
    cx: 250,
    cy: 416.238,
    rx: 193.889,
    ry: 11.323
  })), /*#__PURE__*/React.createElement("g", {
    id: "Window"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M195.683,248.392h-18.811c-20.057,0-36.317-16.26-36.317-36.317V167.16 c0-20.057,16.26-36.317,36.317-36.317h18.811c20.057,0,36.317,16.26,36.317,36.317v44.914 C232,232.132,215.741,248.392,195.683,248.392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M195.683,248.392h-18.811 c-20.057,0-36.317-16.26-36.317-36.317V167.16c0-20.057,16.26-36.317,36.317-36.317h18.811c20.057,0,36.317,16.26,36.317,36.317 v44.914C232,232.132,215.741,248.392,195.683,248.392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M199.291,241.67h-21.569c-16.408,0-29.709-13.301-29.709-29.709v-44.687 c0-16.408,13.301-29.709,29.709-29.709h21.569c16.408,0,29.709,13.301,29.709,29.709v44.687 C229,228.369,215.699,241.67,199.291,241.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M229,167.27v44.69c0,16.41-13.3,29.71-29.71,29.71h-21.57 c-12.31,0-22.87-7.49-27.37-18.16c-1.51-3.55-2.34-7.45-2.34-11.55v-44.69c0-16.4,13.3-29.71,29.71-29.71h21.57 C215.7,137.56,229,150.87,229,167.27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M229,173.23v11.13h-33.9c-5.31,0-9.61-4.3-9.61-9.6c0-5.31,4.3-9.61,9.61-9.61 c0.05,0,0.11,0.01,0.17,0.01c0.08-5.69,4.71-10.27,10.42-10.27c3.77,0,7.07,2.01,8.9,5c0.71-0.13,1.45-0.2,2.2-0.2 c6.58,0,11.92,5.34,11.92,11.92c0,0.59-0.05,1.16-0.13,1.73C228.72,173.3,228.86,173.26,229,173.23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M184.34,217.89c0,3.05-2.42,5.52-5.46,5.62h-28.53c-1.51-3.55-2.34-7.45-2.34-11.55v-15.87 c1.73-1.29,3.88-2.05,6.2-2.05c3.77,0,7.06,2.01,8.89,5.01c0.72-0.13,1.45-0.21,2.2-0.21c6.58,0,11.92,5.34,11.92,11.93 c0,0.58-0.04,1.16-0.12,1.72c0.51-0.15,1.05-0.23,1.61-0.23C181.82,212.26,184.34,214.78,184.34,217.89z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Device"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M291.666,358.56h133.818c5.385,0,9.751-4.366,9.751-9.751V92.543c0-5.385-4.366-9.751-9.751-9.751 H291.666c-5.385,0-9.751,4.366-9.751,9.751v256.266C281.914,354.195,286.28,358.56,291.666,358.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M291.666,358.56h133.818c5.385,0,9.751-4.366,9.751-9.751V92.543 c0-5.385-4.366-9.751-9.751-9.751H291.666c-5.385,0-9.751,4.366-9.751,9.751v256.266 C281.914,354.195,286.28,358.56,291.666,358.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M285.163,358.56h133.819c5.385,0,9.751-4.366,9.751-9.751V92.543c0-5.385-4.366-9.751-9.751-9.751 H285.163c-5.385,0-9.751,4.366-9.751,9.751v256.266C275.412,354.195,279.777,358.56,285.163,358.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M280.877,92.034v256.798c0,2.112,1.356,3.451,3.468,3.451h135.759 c1.941,0,2.893-1.201,2.893-3.142V91.725c0-1.681-0.725-2.884-2.406-2.884h-33.94c-0.958,0-1.828,0.492-2.185,1.394l-1.405,3.311 c-0.357,0.894-1.227,1.362-2.185,1.362h-57.782c-0.959,0-1.828-0.51-2.185-1.404l-1.406-3.302 c-0.357-0.902-1.226-1.36-2.185-1.36h-33.452C282.013,88.84,280.877,90.182,280.877,92.034z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    cx: 355.261,
    cy: 88.908,
    r: 1.962
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M349.327,88.908c0,0.694,0.563,1.257,1.257,1.257 s1.257-0.563,1.257-1.257s-0.563-1.257-1.257-1.257S349.327,88.214,349.327,88.908z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M355.405,341.101v4.761h-7.504v-4.761H355.405  M355.51,339.368h-7.713c-0.899,0-1.628,0.729-1.628,1.629v4.971c0,0.899,0.729,1.628,1.628,1.628h7.713 c0.899,0,1.629-0.729,1.629-1.628v-4.971C357.139,340.097,356.41,339.368,355.51,339.368L355.51,339.368z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 405.618,
    y: 96.564,
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    width: 1.766,
    height: 2.354
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.496,
    y: 95.779,
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    width: 1.766,
    height: 3.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.374,
    y: 94.993,
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    width: 1.766,
    height: 3.925
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.252,
    y: 94.208,
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    width: 1.766,
    height: 4.71
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 296.348,
    y: 95.705,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 593.7428 193.7643)",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    width: 1.047,
    height: 2.354
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.289,
    y: 94.846,
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    width: 8.34,
    height: 4.073
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 280.877,
    y: 106.049,
    style: {
      fill: "#407BFF"
    },
    width: 142.12,
    height: 227.281
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.878,
    y: 106.049,
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    width: 142.12,
    height: 227.281
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#407BFF"
    },
    cx: 299.148,
    cy: 123.848,
    r: 11.944
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M335.84,119.558h-16.988 c-1.388,0-2.514-1.126-2.514-2.514l0,0c0-1.388,1.126-2.514,2.514-2.514h16.988c1.389,0,2.514,1.126,2.514,2.514l0,0 C338.354,118.432,337.229,119.558,335.84,119.558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M368.885,127.1h-51.434c-0.615,0-1.113-0.498-1.113-1.113 l0,0c0-0.615,0.498-1.113,1.113-1.113h51.434c0.615,0,1.113,0.498,1.113,1.113l0,0C369.999,126.602,369.5,127.1,368.885,127.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M353.461,133.166h-36.01 c-0.615,0-1.113-0.498-1.113-1.113l0,0c0-0.615,0.498-1.113,1.113-1.113h36.01c0.615,0,1.113,0.498,1.113,1.113l0,0 C354.574,132.668,354.076,133.166,353.461,133.166z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 280.878,
    y: 143.997,
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    width: 142.12,
    height: 120.421
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M372.072,237.212c0-2.694,2.184-4.878,4.878-4.878c0.487,0,0.957,0.074,1.401,0.206 c-0.071-0.489-0.109-0.989-0.109-1.498c0-5.705,4.625-10.331,10.331-10.331c0.65,0,1.286,0.063,1.903,0.178 c1.588-2.599,4.442-4.339,7.71-4.339c4.946,0,8.959,3.975,9.032,8.903c0.051-0.001,0.1-0.008,0.15-0.008 c4.596,0,8.322,3.726,8.322,8.322s-3.726,8.322-8.322,8.322h-30.562l0.006-0.007C374.183,242.01,372.072,239.86,372.072,237.212z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M292.473,214.187c0-2.024,1.641-3.664,3.664-3.664c0.366,0,0.719,0.055,1.052,0.155 c-0.053-0.367-0.082-0.743-0.082-1.125c0-4.286,3.474-7.76,7.76-7.76c0.488,0,0.966,0.047,1.429,0.134 c1.193-1.952,3.337-3.259,5.791-3.259c3.715,0,6.729,2.985,6.785,6.688c0.038-0.001,0.075-0.006,0.113-0.006 c3.452,0,6.251,2.799,6.251,6.251s-2.799,6.251-6.251,6.251H296.03l0.005-0.005C294.059,217.791,292.473,216.176,292.473,214.187 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M354.167,180.461c0-1.106,0.897-2.003,2.002-2.003c0.2,0,0.393,0.03,0.575,0.085 c-0.029-0.201-0.045-0.406-0.045-0.615c0-2.342,1.899-4.241,4.241-4.241c0.267,0,0.528,0.026,0.781,0.073 c0.652-1.067,1.824-1.781,3.165-1.781c2.03,0,3.678,1.632,3.708,3.655c0.021,0,0.041-0.003,0.062-0.003 c1.887,0,3.416,1.529,3.416,3.416c0,1.887-1.53,3.416-3.416,3.416h-12.545l0.003-0.003 C355.034,182.43,354.167,181.548,354.167,180.461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M325.237,251.139c0-1.434,1.162-2.596,2.596-2.596c0.259,0,0.509,0.039,0.746,0.11 c-0.038-0.26-0.058-0.526-0.058-0.797c0-3.037,2.462-5.498,5.498-5.498c0.346,0,0.684,0.034,1.013,0.095 c0.845-1.383,2.364-2.309,4.104-2.309c2.633,0,4.768,2.115,4.807,4.739c0.027-0.001,0.053-0.004,0.08-0.004 c2.446,0,4.429,1.983,4.429,4.429c0,2.446-1.983,4.429-4.429,4.429h-16.266l0.003-0.004 C326.36,253.693,325.237,252.548,325.237,251.139z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M394.184,193.756c-21.073,7.876-87.783,32.806-87.783,32.806l2.003,5.36 c0,0,16.891,1.739,31.04-3.548c18.087-6.76,46.651-17.434,66.114-24.708c1.972-0.737,6.602-4.135,5.816-6.088 c-1.159-2.881-8.15-2.129-8.15-2.129S398.857,192.01,394.184,193.756z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M312.548,229.656l-13.91-10.063c-0.72-0.521-1.653-0.647-2.485-0.336l-1.645,0.615 c-0.347,0.13-0.47,0.557-0.245,0.852l8.728,11.41l-2.387,0.892c-0.543,0.203-0.819,0.808-0.616,1.351l0,0 c0.203,0.543,0.808,0.819,1.351,0.616l11.059-4.133L312.548,229.656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M372.072,207.704l-49.579-28.439c-0.69-0.396-1.521-0.464-2.267-0.185l-3.939,1.472 c-0.563,0.211-0.741,0.921-0.343,1.371l30.113,34.116L372.072,207.704z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M356.299,223.808l20.124-7.521l-1.263,25.532c-0.069,1.388-0.956,2.602-2.258,3.089l-2.331,0.871 c-0.444,0.166-0.943-0.007-1.189-0.412L356.299,223.808z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M308.401,283.117h-16.988 c-1.388,0-2.514-1.125-2.514-2.514l0,0c0-1.388,1.126-2.514,2.514-2.514h16.988c1.388,0,2.514,1.126,2.514,2.514l0,0 C310.915,281.991,309.789,283.117,308.401,283.117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M409.907,290.659H290.012 c-0.615,0-1.113-0.498-1.113-1.113l0,0c0-0.615,0.498-1.113,1.113-1.113h119.895c0.615,0,1.113,0.498,1.113,1.113l0,0 C411.02,290.16,410.522,290.659,409.907,290.659z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M394.483,297.375H290.012 c-0.615,0-1.113-0.498-1.113-1.113l0,0c0-0.615,0.498-1.113,1.113-1.113h104.471c0.615,0,1.113,0.498,1.113,1.113l0,0 C395.596,296.877,395.097,297.375,394.483,297.375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M298.983,304.091h-8.971 c-0.615,0-1.113-0.498-1.113-1.113l0,0c0-0.615,0.498-1.113,1.113-1.113h8.971c0.615,0,1.113,0.498,1.113,1.113l0,0 C300.097,303.593,299.598,304.091,298.983,304.091z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M403.148,310.807H290.012 c-0.615,0-1.113-0.498-1.113-1.113l0,0c0-0.615,0.498-1.113,1.113-1.113h113.137c0.615,0,1.113,0.498,1.113,1.113l0,0 C404.262,310.309,403.763,310.807,403.148,310.807z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M340.58,317.523h-50.568 c-0.615,0-1.113-0.498-1.113-1.113l0,0c0-0.615,0.498-1.113,1.113-1.113h50.568c0.615,0,1.113,0.498,1.113,1.113l0,0 C341.693,317.025,341.194,317.523,340.58,317.523z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M371.939,166.315h-39.755c-3.645,0-6.601-2.955-6.601-6.601l0,0c0-3.645,2.955-6.601,6.601-6.601 h39.755c3.646,0,6.601,2.955,6.601,6.601l0,0C378.539,163.359,375.584,166.315,371.939,166.315z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M338.842,161.339c0,0.275-0.055,0.516-0.165,0.724c-0.11,0.207-0.261,0.382-0.454,0.522 c-0.192,0.141-0.415,0.247-0.668,0.321c-0.254,0.073-0.524,0.11-0.811,0.11h-3.142v-6.504h3.481 c0.226,0,0.431,0.049,0.614,0.146c0.184,0.098,0.339,0.225,0.467,0.38c0.128,0.156,0.227,0.332,0.298,0.531 c0.07,0.198,0.105,0.399,0.105,0.6c0,0.317-0.08,0.615-0.238,0.893c-0.159,0.278-0.391,0.484-0.696,0.618 c0.373,0.11,0.667,0.307,0.884,0.591C338.734,160.556,338.842,160.912,338.842,161.339z M334.867,157.593v1.64h1.685 c0.214,0,0.396-0.073,0.546-0.22c0.149-0.147,0.224-0.348,0.224-0.605c0-0.25-0.069-0.449-0.206-0.595s-0.307-0.22-0.508-0.22 H334.867z M337.569,161.101c0-0.116-0.02-0.228-0.06-0.335c-0.04-0.106-0.093-0.2-0.161-0.279 c-0.067-0.079-0.146-0.142-0.238-0.188c-0.092-0.045-0.192-0.068-0.302-0.068h-1.942v1.713h1.878 c0.116,0,0.225-0.021,0.325-0.064c0.101-0.043,0.188-0.103,0.261-0.179c0.073-0.076,0.131-0.167,0.174-0.271 C337.548,161.327,337.569,161.217,337.569,161.101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M342.607,163.061c-0.477,0-0.909-0.093-1.296-0.279c-0.388-0.186-0.721-0.434-0.999-0.742 c-0.278-0.308-0.493-0.661-0.646-1.058c-0.153-0.397-0.229-0.803-0.229-1.218c0-0.434,0.081-0.849,0.243-1.246 c0.162-0.396,0.385-0.748,0.668-1.053c0.284-0.305,0.622-0.548,1.012-0.729c0.391-0.18,0.815-0.27,1.273-0.27 c0.47,0,0.899,0.096,1.287,0.289s0.719,0.444,0.994,0.756c0.274,0.311,0.488,0.665,0.641,1.063 c0.152,0.397,0.229,0.8,0.229,1.209c0,0.434-0.08,0.848-0.238,1.242c-0.159,0.394-0.379,0.742-0.66,1.044 c-0.281,0.302-0.617,0.544-1.007,0.724C343.49,162.971,343.065,163.061,342.607,163.061z M340.72,159.764 c0,0.281,0.042,0.553,0.128,0.815c0.086,0.263,0.209,0.495,0.371,0.696c0.162,0.202,0.36,0.364,0.595,0.486 c0.235,0.122,0.503,0.183,0.802,0.183c0.305,0,0.575-0.063,0.81-0.188c0.235-0.125,0.434-0.292,0.595-0.499 c0.162-0.208,0.284-0.441,0.367-0.701c0.083-0.26,0.124-0.524,0.124-0.792c0-0.281-0.044-0.553-0.133-0.816 c-0.088-0.262-0.214-0.495-0.376-0.696c-0.162-0.201-0.36-0.362-0.596-0.481c-0.235-0.119-0.499-0.178-0.792-0.178 c-0.306,0-0.577,0.063-0.815,0.188c-0.238,0.126-0.437,0.29-0.596,0.495c-0.159,0.205-0.279,0.437-0.362,0.696 C340.762,159.231,340.72,159.495,340.72,159.764z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M349.533,163.061c-0.477,0-0.909-0.093-1.296-0.279c-0.388-0.186-0.721-0.434-0.999-0.742 c-0.278-0.308-0.493-0.661-0.646-1.058c-0.153-0.397-0.229-0.803-0.229-1.218c0-0.434,0.08-0.849,0.243-1.246 c0.162-0.396,0.385-0.748,0.668-1.053c0.284-0.305,0.622-0.548,1.012-0.729c0.391-0.18,0.816-0.27,1.273-0.27 c0.47,0,0.899,0.096,1.287,0.289s0.719,0.444,0.994,0.756c0.274,0.311,0.488,0.665,0.641,1.063 c0.152,0.397,0.229,0.8,0.229,1.209c0,0.434-0.08,0.848-0.238,1.242c-0.159,0.394-0.379,0.742-0.66,1.044 c-0.281,0.302-0.617,0.544-1.007,0.724C350.415,162.971,349.991,163.061,349.533,163.061z M347.646,159.764 c0,0.281,0.042,0.553,0.128,0.815c0.086,0.263,0.209,0.495,0.371,0.696c0.162,0.202,0.36,0.364,0.595,0.486 c0.235,0.122,0.503,0.183,0.802,0.183c0.305,0,0.575-0.063,0.811-0.188c0.235-0.125,0.434-0.292,0.595-0.499 c0.162-0.208,0.284-0.441,0.367-0.701c0.082-0.26,0.123-0.524,0.123-0.792c0-0.281-0.044-0.553-0.133-0.816 c-0.088-0.262-0.214-0.495-0.376-0.696c-0.162-0.201-0.36-0.362-0.596-0.481c-0.235-0.119-0.499-0.178-0.792-0.178 c-0.306,0-0.577,0.063-0.815,0.188c-0.238,0.126-0.437,0.29-0.596,0.495c-0.159,0.205-0.279,0.437-0.362,0.696 C347.687,159.231,347.646,159.495,347.646,159.764z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M353.682,163.016v-6.495h1.264v3.087l2.73-3.096h1.392l-2.492,2.885l2.648,3.619h-1.42 l-2.024-2.813l-0.834,0.871v1.942H353.682z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M364.327,161.907v1.108h-4.516v-6.504h4.434v1.108h-3.17v1.566h2.739v1.026h-2.739v1.695H364.327 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M365.316,163.016v-6.504h2.364c0.531,0,0.997,0.085,1.397,0.256 c0.4,0.171,0.734,0.403,1.003,0.696c0.269,0.293,0.47,0.637,0.605,1.031c0.134,0.394,0.202,0.813,0.202,1.259 c0,0.495-0.075,0.942-0.225,1.342c-0.149,0.4-0.365,0.742-0.646,1.026c-0.281,0.284-0.619,0.504-1.012,0.66 c-0.394,0.156-0.835,0.233-1.324,0.233H365.316z M369.612,159.754c0-0.311-0.043-0.598-0.128-0.861 c-0.085-0.263-0.21-0.489-0.375-0.678c-0.165-0.189-0.368-0.335-0.609-0.439c-0.242-0.104-0.515-0.156-0.82-0.156h-1.1v4.287 h1.1c0.311,0,0.587-0.055,0.829-0.165c0.241-0.11,0.443-0.261,0.605-0.453c0.162-0.192,0.285-0.42,0.371-0.683 C369.569,160.344,369.612,160.06,369.612,159.754z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M98.977,394.714l28.813-2.832v-40.492h11.419v40.481l28.929,2.843 c2.872,0.282,5.061,2.697,5.061,5.583v4.327h-38.583h-2.117H93.916v-4.327C93.916,397.411,96.105,394.996,98.977,394.714z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M98.977,394.714l28.813-2.832v-40.492h11.419v40.481 l28.929,2.843c2.872,0.282,5.061,2.697,5.061,5.583v4.327h-38.583h-2.117H93.916v-4.327 C93.916,397.411,96.105,394.996,98.977,394.714z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#263238"
    },
    cx: 170.15,
    cy: 409.99,
    r: 7.466
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#263238"
    },
    cx: 96.965,
    cy: 409.99,
    r: 7.466
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M129.956,360.093h7.086c2.283,0,4.133-1.851,4.133-4.133v-31.933h-15.352v31.933 C125.823,358.242,127.674,360.093,129.956,360.093z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M129.956,360.093h7.086c2.283,0,4.133-1.851,4.133-4.133 v-31.933h-15.352v31.933C125.823,358.242,127.674,360.093,129.956,360.093z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M125.148,227.497c0.173,27.658,3.016,84.231,22.903,96.529H92.793 c-1.988,0-3.816-1.067-4.793-2.799c-4.887-8.665-18.339-37.918-16.058-94.247c0.335-8.266,7.152-14.794,15.424-14.794h22.348 C118.191,212.187,125.095,219.02,125.148,227.497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M131.148,227.497c0.173,27.658,3.016,84.231,22.903,96.529H95.724 c0,0-20.56-28.441-17.781-97.046c0.335-8.266,7.152-14.794,15.424-14.794h22.348 C124.191,212.187,131.095,219.02,131.148,227.497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M131.148,227.497 c0.173,27.658,3.016,84.231,22.903,96.529H95.724c0,0-20.56-28.441-17.781-97.046c0.335-8.266,7.152-14.794,15.424-14.794 h22.348C124.191,212.187,131.095,219.02,131.148,227.497z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M167.968,316.475h-66.921c-2.761,0-5,2.239-5,5v6.689h76.921v-6.689 C172.968,318.714,170.73,316.475,167.968,316.475z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M174.163,322.32H94.853c-1.111,0-2.011,0.901-2.011,2.011v1.822c0,1.111,0.9,2.011,2.011,2.011 h79.311c1.111,0,2.011-0.901,2.011-2.011v-1.822C176.175,323.221,175.274,322.32,174.163,322.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M174.163,322.32H94.853c-1.111,0-2.011,0.901-2.011,2.011 v1.822c0,1.111,0.9,2.011,2.011,2.011h79.311c1.111,0,2.011-0.901,2.011-2.011v-1.822 C176.175,323.221,175.274,322.32,174.163,322.32z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "200.887,417.455 207.013,417.455 218.02,264.208 209.893,264.208  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    points: "200.883,417.455 207.013,417.455 217.483,271.82  218.023,264.455 209.893,264.455 209.453,271.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    points: "209.453,271.455 217.483,271.455 218.023,264.455  209.893,264.455  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4897B"
    },
    d: "M218.66,377.82l-6.94-0.67c0,0-8.15-22.23-16.28-42.13c-6.56-16.05-13.1-30.57-15.33-30.66 c-0.49-0.02-1.45,0.19-2.8,0.59c-12.41,3.63-57.63,22.38-69.14,10.67c-12.76-12.97,5.69-44.24,5.69-44.24s30.69-4.38,33,2.55 c0.45,1.34,0.94,3.97,1.3,6.22c0.35,2.12,0.59,3.9,0.59,3.9s0.01,0,0.02-0.01c0.95-0.24,31.76-8.19,43.9,0.01 C205,292.39,218.66,377.82,218.66,377.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E353A"
    },
    d: "M229.395,389.551c-1-0.46-2.075-0.733-3.174-0.806l0,0c0,0-3.798-2.236-7.562-10.92l-4.233-0.025 c-1.465,0.017-2.765,0.947-3.252,2.329c-0.07,0.188-0.11,0.386-0.12,0.586c0.043,1.023,0.151,2.042,0.325,3.051 c0.381,3.166,2.475,9.959,2.475,9.959l0.717-0.183l-1.304-6.316c-0.434-2.146,1.821-0.073,2.867,2.091 c1.046,2.164,2.65,4.342,7.325,3.273C228.907,391.316,231.103,390.531,229.395,389.551z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4897B"
    },
    d: "M217.893,375.549c0,0,5.285,11.061,8.329,13.195c0,0-4.08,2.433-8.329-2.982 c-5.494-7.003-6.838-5.047-6.838-5.047s0.233-2.397,0.661-3.57C212.542,374.887,217.893,375.549,217.893,375.549z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E353A"
    },
    d: "M171.174,415.904c-0.862-0.684-1.842-1.205-2.892-1.536l0,0c0,0-3.159-3.073-4.757-12.402 l-4.107-1.028c-1.428-0.331-2.91,0.265-3.712,1.492c-0.112,0.166-0.198,0.349-0.255,0.541 c-0.201,1.004-0.337,2.019-0.408,3.041c-0.381,3.166,0.042,10.261,0.042,10.261l0.74-0.007l0.231-6.445 c0.088-2.188,1.787,0.361,2.29,2.711c0.503,2.35,1.545,4.846,6.34,4.917C170.282,417.503,172.601,417.261,171.174,415.904z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4897B"
    },
    d: "M163.321,399.574c0,0,2.512,11.999,4.962,14.794c0,0-4.541,1.396-7.384-4.872 c-3.676-8.106-5.447-6.525-5.447-6.525s0.795-2.273,1.489-3.311C158.279,397.661,163.321,399.574,163.321,399.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M163.321,399.574c0,0,2.512,11.999,4.962,14.794 c0,0-4.541,1.396-7.384-4.872c-3.676-8.106-5.447-6.525-5.447-6.525s0.795-2.273,1.489-3.311 C158.279,397.661,163.321,399.574,163.321,399.574z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M195.44,335.02c-6.56-16.05-13.1-30.57-15.33-30.66 c-0.49-0.02-1.45,0.19-2.8,0.59l0.09-3.65c0,0,8.59,0.29,14.92,7.15C196.61,313.1,196.17,326.74,195.44,335.02z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4897B"
    },
    d: "M130.21,318.742c0,0,34.775-3.65,38.405-0.509c3.803,3.291-5.38,9.931-11.674,81.426 l6.584,2.306c0,0,26.145-77.175,25.895-87.425s-12-13.25-12-13.25S154.486,314.541,130.21,318.742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M189.42,314.54c0.25,10.25-25.89,87.43-25.89,87.43l-6.59-2.31 c6.3-71.5,15.48-78.14,11.68-81.43c-0.82-0.71-3.27-1.07-6.55-1.2c-5.88-0.25-14.45,0.24-21.23,0.77 c-6.03,0.46-10.63,0.94-10.63,0.94c3.07-0.53,6.12-1.21,9.11-1.99c20.24-5.26,37.47-15.1,38.08-15.45 c0.01,0,0.02-0.01,0.02-0.01S189.17,304.29,189.42,314.54z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M177.4,301.3c-0.48,0.41-10.15,8.68-15.33,15.73 c-5.88-0.25-14.45,0.24-21.23,0.77c-0.65-0.44-1.17-0.8-1.52-1.05C159.56,311.49,176.79,301.65,177.4,301.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M170.968,280.509l-16.695,46.205c0,0-40.229-0.989-48.141-9.099 c-7.912-8.11-5.143-21.56,0.989-31.055c6.132-9.495,36.989-11.275,36.989-11.275l6.574,8.292 C150.684,283.578,161.817,280.513,170.968,280.509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M170.97,280.51l-16.7,46.2c0,0-40.23-0.98-48.14-9.09 c-7.91-8.11-5.14-21.57,0.99-31.06c6.13-9.49,36.99-11.27,36.99-11.27l3.89,4.91l2.52,3.18l0.16,0.2 C150.68,283.58,161.82,280.51,170.97,280.51z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      enableBackground: "new"
    },
    d: "M150.52,283.38l-19.72,4.41c0,0,9.78-5.4,17.2-7.59L150.52,283.38z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M146.86,273.93l3.82,9.65l-9.29,2.01l-4.93-5.14l-10.95,10.73l-25.05,1.2l13.4-21l-1.25-16.41 l-1.39-18.29l-1.16-15.26c0,0,12.66-5.15,23.24-4.6c10.59,0.54,19.02,1.9,19.02,1.9C158.87,234.54,146.86,273.93,146.86,273.93z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M146.86,273.93l3.82,9.65l-9.29,2.01l-4.93-5.14l-10.95,10.73 l-25.05,1.2l13.4-21l-1.25-16.41l-1.39-18.29l-1.16-15.26c0,0,12.66-5.15,23.24-4.6c10.59,0.54,19.02,1.9,19.02,1.9 C158.87,234.54,146.86,273.93,146.86,273.93z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M84.162,216.182c0.222,0.46,0.008,0.97-0.477,1.139l-8.628,3.014 c-0.485,0.169-1.058-0.066-1.28-0.526l-7.875-16.356c-0.222-0.46-0.05-1.088,0.435-1.257l8.628-3.014 c0.485-0.169,1.099,0.184,1.321,0.644L84.162,216.182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M75.291,200.049l7.958,16.512c0.225,0.465,0.087,0.883-0.394,1.051l-7.316,2.556 c-0.491,0.171-1.485,0.215-1.709-0.25l-7.979-16.571c-0.225-0.465,0.477-1.146,0.968-1.318l7.316-2.556 C74.617,199.304,75.066,199.583,75.291,200.049z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4897B"
    },
    d: "M81.705,234.74l-5.837-11.674c0,0,4.154-9.12,2.868-10.349c-1.285-1.23-2.67-5.75-5.044-6.107 c-2.374-0.357-5.341,10.467-5.341,11.412c0,0.945,2.176,6.428,2.176,6.428l5.138,15.999L81.705,234.74z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4897B"
    },
    d: "M163.2,210.01l-4.35,4.75l-3.37-4.35c0,0-0.59,1.48-1.5,1.56c-0.91,0.08-6.51,2.99-7.52,1.87 c-0.31-0.35-0.59-1.12-0.83-2.01c-0.54-1.99-0.87-4.59-0.87-4.59s9.44-5.44,10.53-4.59c0.12,0.09,0.3,0.25,0.53,0.45 C157.76,204.82,163.2,210.01,163.2,210.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M155.82,203.1c-0.61,2.98-2.76,7.55-10.19,8.73 c-0.54-1.99-0.87-4.59-0.87-4.59s9.44-5.44,10.53-4.59C155.41,202.74,155.59,202.9,155.82,203.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M181.69,238.89c-3.02,6.72-14.38,4.28-22.2,1.63c-4.44-1.51-7.75-3.08-7.75-3.08l0.19-6.11 l0.39-12.61l8.94,5.73l6.33,4.06l-11.57-16.54l5.5-5.36C161.52,206.61,186.44,228.35,181.69,238.89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M181.69,238.89c-3.02,6.72-14.38,4.28-22.2,1.63 c-4.44-1.51-7.75-3.08-7.75-3.08l0.19-6.11l0.39-12.61l8.94,5.73l6.33,4.06l-11.57-16.54l5.5-5.36 C161.52,206.61,186.44,228.35,181.69,238.89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M159.49,240.52c-4.44-1.51-7.75-3.08-7.75-3.08l0.19-6.11l1.96-4.75 C153.89,226.58,158.26,233.47,159.49,240.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M170.97,234.74c0,0-8.75-2.92-9.71-10.29l6.33,4.06L170.97,234.74z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M125.493,251.294h3.943c0.437,0,0.791-0.354,0.791-0.791 v-7.439c0-0.437-0.354-0.791-0.791-0.791h-3.943c-0.437,0-0.791,0.354-0.791,0.791v7.439 C124.701,250.94,125.056,251.294,125.493,251.294z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.413,
    y: 242.866,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 255.3097 491.8641)",
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    width: 4.484,
    height: 6.132
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.061,
    y: 240.097,
    style: {
      fill: "#263238"
    },
    width: 0.989,
    height: 3.614
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M112.61,254.97l-1.39-18.29l3.04-2.74 C114.26,233.94,117.51,244.86,112.61,254.97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M123.538,221.417c0,0,11.708,27.65,12.579,37.793 c0,0,7.709-24.095,6.79-35.964L123.538,221.417z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M117.407,222.67c0,0,3.126-10.879,15.013-9.89c11.888,0.989,16.447,12.139,16.447,12.139 l-5.558-2.843l-6.32,18.372l-11.481-18.174L117.407,222.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M117.407,222.67c0,0,3.126-10.879,15.013-9.89 c11.888,0.989,16.447,12.139,16.447,12.139l-5.558-2.843l-6.32,18.372l-11.481-18.174L117.407,222.67z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M127.239,181.794c0,0-0.557-4.967-7.151-5.353c-6.593-0.386-12.132,4.279-8.176,12.232 c3.956,7.954,4.074,16.852-1.326,17.941c0,0,10.601,4.904,12.535-11.779L127.239,181.794z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M144.989,179.503c0,0-6.146-7.536-18.029,1.036c-11.883,8.571-2.557,26.506,6.692,25.979 C142.901,205.989,144.989,179.503,144.989,179.503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4897B"
    },
    d: "M140.12,215.23c0.07,2.07,0.94,3.72,0.94,3.72l-4.862,14.001L124.68,217.67 c4.11-0.53,6.51-5.6,7.74-9.37c0.64-1.95,0.96-3.55,1.04-4c0.02-0.09,0.03-0.13,0.03-0.13l0.26,0.15l9.28,5.23 C140.62,211.2,140.05,213.38,140.12,215.23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M143.03,209.55c-2.41,1.65-2.98,3.83-2.91,5.68 c-4.37-1.33-6.58-4.38-7.7-6.93c0.64-1.95,0.96-3.55,1.04-4l0.29,0.02L143.03,209.55z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M134.531,179.185c0,0,6.955-5.965,15.081-2.009c8.125,3.956,7.983,16.078,2.567,20.192 C146.761,201.482,134.531,179.185,134.531,179.185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4897B"
    },
    d: "M139.465,181.698c8.483-0.842,11.663,3.429,13.152,12.109c1.86,10.847,0.208,18.849-10.63,17.568 C127.269,209.635,125.378,183.096,139.465,181.698z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DE5753"
    },
    d: "M147.087,193.877c0,0,1.395,2.099,2.817,3.273c0,0-0.612,1.226-2.141,1.181L147.087,193.877z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M141.826,193.699c0.086,0.695-0.221,1.305-0.684,1.362c-0.464,0.057-0.908-0.46-0.994-1.156 s0.221-1.305,0.684-1.362S141.74,193.003,141.826,193.699z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M140.643,192.6l1.439-0.779C142.082,191.821,141.486,193.186,140.643,192.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M150.45,192.492c0.085,0.695-0.221,1.305-0.684,1.362c-0.464,0.057-0.908-0.46-0.994-1.156 c-0.086-0.695,0.221-1.305,0.684-1.362C149.92,191.279,150.365,191.797,150.45,192.492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M149.267,191.394l1.439-0.779C150.706,190.615,150.11,191.98,149.267,191.394z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.7247,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M141.159,187.849c0,0-2.414-0.073-3.552,1.647"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.7247,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M147.29,186.879c0,0,1.443-0.704,3.45,0.362"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M131.613,196.915c0,0,3.275-7.363,2.14-12.684c0,0,16.128-8.535,18.651,8.445 c0,0,0.139-15.313-14.476-14.204c-14.592,1.107-12.437,22.436-4.276,28.045C133.652,206.517,129.592,201.517,131.613,196.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4897B"
    },
    d: "M133.176,198.568c-0.192-1.36-1.831-3.532-4.343-3.003c-2.6,0.548-3.318,6.068,3.35,6.717 C133.139,202.375,133.577,201.406,133.176,198.568z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M148.867,201.648c-0.423,1.058-0.795,3.02-0.795,3.02c-0.184-0.002-0.368-0.003-0.551-0.015 c-2.492-0.085-3.62-0.948-4.115-1.879c-0.269-0.51-0.342-1.047-0.345-1.483c-0.008-0.504,0.101-0.865,0.101-0.865 c1.294,0.834,3.612,1.093,4.855,1.179C148.538,201.647,148.867,201.648,148.867,201.648z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M148.018,201.606l-0.257,0.884c-2.347-0.086-3.988-0.461-4.699-1.198 c-0.008-0.504,0.101-0.865,0.101-0.865C144.457,201.261,146.774,201.52,148.018,201.606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DE5753"
    },
    d: "M147.521,204.654c-2.492-0.085-3.62-0.948-4.115-1.879c0.848,0.062,1.864,0.23,2.749,0.643 C146.832,203.73,147.249,204.192,147.521,204.654z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M153.358,189.708c0,0-1.865-0.678-5.337,0.549l-0.004-0.013c0,0-1.576-0.565-3.096,0.35 c-1.05-0.01-3.513,0.108-6.372,1.228l-6.626,2.514v0.73l6.758-1.742c0.561,1.661,2.067,4.201,4.349,3.732 c3.037-0.624,2.845-3.766,2.619-5.234c0.639-0.744,1.851-0.849,2.095-0.282c0.249,1.303,1.081,4.298,4.257,4.122 C155.214,195.484,153.358,189.708,153.358,189.708z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M153.358,189.708c0,0-1.865-0.678-5.337,0.549l-0.004-0.013 c0,0-1.576-0.565-3.096,0.35c-1.05-0.01-3.513,0.108-6.372,1.228l-6.626,2.514v0.73l6.758-1.742 c0.561,1.661,2.067,4.201,4.349,3.732c3.037-0.624,2.845-3.766,2.619-5.234c0.639-0.744,1.851-0.849,2.095-0.282 c0.249,1.303,1.081,4.298,4.257,4.122C155.214,195.484,153.358,189.708,153.358,189.708z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M152.223,190.132l-1.335,4.933c0,0,1.882,0.63,2.387-0.878c0.505-1.508-0.137-4.055-0.137-4.055 S152.569,190.033,152.223,190.132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M151.788,190.088l-1.324,4.977c0,0-0.844-0.26-0.853-0.581l1.095-4.253 C150.706,190.231,151.478,190.118,151.788,190.088z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M143.743,191.348l-1.335,4.933c0,0,1.882,0.63,2.387-0.878c0.505-1.508-0.137-4.055-0.137-4.055 S144.089,191.249,143.743,191.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M143.309,191.304l-1.324,4.977c0,0-0.844-0.26-0.853-0.581l1.095-4.253 C142.227,191.447,142.998,191.335,143.309,191.304z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M139.17,181.373c0,0,1.983,9.427-4.639,13.462"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M139.353,182.356c0,0-2.033,14.297-10.839,14.99c-8.806,0.693-0.466-15.24,3.003-18.325 C133.108,177.605,138.681,175.659,139.353,182.356z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M110.057,221.417c-3.793,0.529-15.925,25.197-18.826,25.202 c-2.901,0.005-11.977-19.187-11.977-19.187l-7.54,5.519c0,0,8.998,30.775,19.171,29.339 c11.027-1.556,23.027-19.528,23.027-19.528s0.791-6.311,0-11.85C113.121,225.374,110.057,221.417,110.057,221.417z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M110.057,221.417c-3.793,0.529-15.925,25.197-18.826,25.202 c-2.901,0.005-11.977-19.187-11.977-19.187l-7.54,5.519c0,0,8.998,30.775,19.171,29.339 c11.027-1.556,23.027-19.528,23.027-19.528s0.791-6.311,0-11.85C113.121,225.374,110.057,221.417,110.057,221.417z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 244.687,
    y: 211.643,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.839,
    height: 32.72
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.687,
    y: 211.643,
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    width: 20.839,
    height: 32.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 239.142,
    y: 211.643,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.839,
    height: 32.72
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.142,
    y: 211.643,
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    width: 20.839,
    height: 32.72
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "267.11,213.382 267.11,256.89 238.231,256.89 238.231,224.471 253.22,213.382  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.34,
    y: 213.382,
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    width: 8.77,
    height: 43.508
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.676,
    y: 220.209,
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    width: 6.53,
    height: 3.047
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.676,
    y: 225.206,
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    width: 6.53,
    height: 9.871
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.676,
    y: 237.758,
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    width: 6.53,
    height: 2.559
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 229.687,
    y: 210.643,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.839,
    height: 32.72
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.687,
    y: 210.643,
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    width: 20.839,
    height: 32.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 224.142,
    y: 210.643,
    style: {
      fill: "#FFFFFF"
    },
    width: 20.839,
    height: 32.72
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.142,
    y: 210.643,
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    width: 20.839,
    height: 32.72
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "252.11,213.382 252.11,256.89 223.231,256.89 223.231,224.471 238.22,213.382  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.34,
    y: 213.382,
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    width: 8.77,
    height: 43.508
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.676,
    y: 220.209,
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    width: 6.53,
    height: 3.047
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.676,
    y: 225.206,
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    width: 6.53,
    height: 9.871
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.676,
    y: 237.758,
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    width: 6.53,
    height: 2.559
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "203.928,417.455 210.054,417.455 211.055,264.208 202.927,264.208  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    points: "202.923,264.455 203.083,289.18  203.923,417.455 210.053,417.455 210.893,289.18 211.053,264.455  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    points: "202.923,264.455 203.083,289.455 210.893,289.455  211.053,264.455  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "138.887,417.455 145.013,417.455 156.02,264.208 147.893,264.208  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    points: "138.883,417.455 145.013,417.455  155.483,271.82 156.023,264.455 147.893,264.455 147.453,271.82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    points: "147.453,271.455 155.483,271.455 156.023,264.455  147.893,264.455  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "270.969,417.455 277.095,417.455 268.089,264.208 259.962,264.208  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    points: "259.963,264.455 260.503,271.82  270.973,417.455 277.093,417.455 268.533,271.82 268.093,264.455  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    points: "268.093,264.455 259.963,264.455 260.503,271.455  268.533,271.455  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M143.613,268.046H272.37c1.194,0,2.162-0.968,2.162-2.162v-5.514H141.45v5.513 C141.45,267.078,142.418,268.046,143.613,268.046z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M143.613,268.046H272.37 c1.194,0,2.162-0.968,2.162-2.162v-5.514H141.45v5.513C141.45,267.078,142.418,268.046,143.613,268.046z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 141.45,
    y: 260.371,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 415.9819 524.5792)",
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    width: 133.081,
    height: 3.838
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M137.653,261.371h140.676c1.194,0,2.162-0.968,2.162-2.162l0,0c0-1.194-0.968-2.162-2.162-2.162 H137.653c-1.194,0-2.162,0.968-2.162,2.162l0,0C135.491,260.403,136.459,261.371,137.653,261.371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M137.653,261.371h140.676 c1.194,0,2.162-0.968,2.162-2.162l0,0c0-1.194-0.968-2.162-2.162-2.162H137.653c-1.194,0-2.162,0.968-2.162,2.162l0,0 C135.491,260.403,136.459,261.371,137.653,261.371z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M236.492,252.951v2.646c0,0.793-1.365,1.354-2.148,1.354H172.55 c-0.793,0-2.058-0.561-2.058-1.354v-2.646H236.492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M236.492,252.951v2.646c0,0.793-1.365,1.354-2.148,1.354 H172.55c-0.793,0-2.058-0.561-2.058-1.354v-2.646H236.492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M236.492,252.951v2.646c0,0.793-1.365,1.354-2.148,1.354h-40.757 c-0.793,0-2.095-0.561-2.095-1.354v-2.646H236.492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M246.401,220.464l-7.356,33.479c-0.239,1.099-1.309,2.008-2.388,2.008h-40.183 c-1.07,0-1.758-1.142-1.51-2.241l7.347-33.12c0.248-1.089,1.309-1.64,2.389-1.64h40.183 C245.962,218.951,246.64,219.375,246.401,220.464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M246.401,220.464l-7.356,33.479 c-0.239,1.099-1.309,2.008-2.388,2.008h-40.183c-1.07,0-1.758-1.142-1.51-2.241l7.347-33.12c0.248-1.089,1.309-1.64,2.389-1.64 h40.183C245.962,218.951,246.64,219.375,246.401,220.464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M246.401,220.464l-7.356,33.479 c-0.239,1.099-1.309,2.008-2.388,2.008h-38.817c-1.08,0-1.758-1.142-1.519-2.241l7.357-33.12c0.239-1.089,1.309-1.64,2.389-1.64 h38.817C245.962,218.951,246.64,219.375,246.401,220.464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M222.762,241.921c1.87,0,3.79-2.01,4.28-4.48 c0.48-2.48-0.64-4.49-2.52-4.49c-0.35,0-0.7,0.07-1.04,0.2c-0.44,1.93-1.75,3.55-3.19,4.09c-0.02,0.07-0.04,0.13-0.05,0.2 C219.752,239.911,220.883,241.921,222.762,241.921z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M100.329,324.274L100.329,324.274c-1.113,0-2.023-0.909-2.002-2.022 c0.421-22.821,7.881-37.694,10.802-42.666c0.589-1.002,1.912-1.282,2.866-0.617l1.557,1.088l-1.64-1.146l0.09,0.062 c0.85,0.592,1.113,1.738,0.594,2.635c-2.64,4.559-9.85,18.948-10.269,40.683C102.306,323.389,101.425,324.274,100.329,324.274z "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M100.329,324.274L100.329,324.274c-1.113,0-2.023-0.909-2.002-2.022 c0.421-22.821,7.881-37.694,10.802-42.666c0.589-1.002,1.912-1.282,2.866-0.617l1.557,1.088l-1.64-1.146l0.09,0.062 c0.85,0.592,1.113,1.738,0.594,2.635c-2.64,4.559-9.85,18.948-10.269,40.683C102.306,323.389,101.425,324.274,100.329,324.274z "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M125.758,282.077H70.374c-1.821,0-3.297-1.476-3.297-3.297l0,0c0-1.821,1.476-3.297,3.297-3.297 h55.385c1.821,0,3.297,1.476,3.297,3.297l0,0C129.055,280.601,127.579,282.077,125.758,282.077z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M125.758,282.077H70.374 c-1.821,0-3.297-1.476-3.297-3.297l0,0c0-1.821,1.476-3.297,3.297-3.297h55.385c1.821,0,3.297,1.476,3.297,3.297l0,0 C129.055,280.601,127.579,282.077,125.758,282.077z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnquiry);
export default __webpack_public_path__ + "static/media/enquiry.621807273aa0a5aced42b51acea8efb1.svg";
export { ForwardRef as ReactComponent };